import { Button, ButtonLevel, ButtonSize } from '@vizit/atoms';
import { XCloseIcon } from '@vizit/icons';
import { cva, cx } from '@vizit/theme';
import type * as React from 'react';

const styles = {
  banner: cva({
    base: [
      'w-full min-h-[56px] px-16 py-4',
      'flex items-center justify-between',
      'z-50 bg-brand-600 text-primary-on-brand outline-none',
      'max-sm:min-h-[48px] max-sm:px-8 max-sm:py-3',
    ],
  }),
  content: cva({ base: 'flex-1 flex items-center' }),
  dismissButton: cva({ base: 'text-primary-on-brand bg-brand-600 hover:bg-brand-700 hover:text-primary-on-brand' }),
};

interface VerticalNavbarBannerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  isOpen?: boolean;
  showDismiss?: boolean;
  buttonClassName?: string;
  onDismiss?: () => void;
}

function VerticalNavbarBanner(props: VerticalNavbarBannerProps) {
  const { children, isOpen = true, showDismiss = true, className, buttonClassName, onDismiss, ...other } = props;

  if (!isOpen) {
    return null;
  }

  return (
    <output aria-live="polite" aria-atomic="true">
      <div className={cx(styles.banner(), className)} {...other}>
        <div className={styles.content()}>{children}</div>
        {showDismiss && onDismiss && (
          <Button
            level={ButtonLevel['Text-Secondary']}
            size={ButtonSize.Sm}
            className={cx(styles.dismissButton(), buttonClassName)}
            aria-label="Dismiss banner"
            onPress={onDismiss}
          >
            <XCloseIcon size={16} aria-hidden="true" />
          </Button>
        )}
      </div>
    </output>
  );
}

export { VerticalNavbarBanner };
export type { VerticalNavbarBannerProps };
